import _ from 'lodash';

export function matchOnKeyValues<T>(object: T, keys: string[], pattern: RegExp): boolean {
  for (let i = 0; i < keys.length; i += 1) {
    const value = _.get(object, keys[i]);
    if (_.isString(value) && value.match(pattern)) return true;
  }
  return false;
}

export function search<T>(arr: T[], keys: string[], pattern: RegExp): T[] {
  return arr.filter((object: T) => matchOnKeyValues(object, keys, pattern));
}

interface JWTClaims<T> {
  exp: number,
  data: T
}

export function decodeJWT<T>(jwt: string): JWTClaims<T> {
  const base64Url = jwt.split('.')[1];
  const base64 = base64Url
    .replace('-', '+')
    .replace('_', '/');

  return JSON.parse(window.atob(base64));
}
